var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 12.5C28.2761 12.5 28.5 12.2761 28.5 12C28.5 11.7239 28.2761 11.5 28 11.5C27.7239 11.5 27.5 11.7239 27.5 12C27.5 12.2761 27.7239 12.5 28 12.5Z",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.5C28.2761 18.5 28.5 18.2761 28.5 18C28.5 17.7239 28.2761 17.5 28 17.5C27.7239 17.5 27.5 17.7239 27.5 18C27.5 18.2761 27.7239 18.5 28 18.5Z",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.5C28.2761 6.5 28.5 6.27614 28.5 6C28.5 5.72386 28.2761 5.5 28 5.5C27.7239 5.5 27.5 5.72386 27.5 6C27.5 6.27614 27.7239 6.5 28 6.5Z",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.c71e6b163174de53cb541e08407f7808.svg";
export { ForwardRef as ReactComponent };